<template>
    <section class="home-container">
        <MasterPage title="问卷管理">
            <div slot="title-icon">
                <Icon type="md-paper" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="问卷标题：">
                            <Input v-model="select.name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="问卷类型：">
                            <Select v-model="select.typeId" clearable placeholder="请选择">
                                <Option v-for="item in QuestionnaireTypeAllList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="发布状态：">
                            <Select v-model="select.status" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="未发布">未发布</Option>
                                <Option value="已发布">已发布</Option>
                                <Option value="已回收">已回收</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="问卷状态：">
                            <Select v-model="select.isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true">禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" style="margin: 0 5px" icon="md-add" @click="addModel=true">添加问卷</Button>

                <Button type="primary" style="margin: 0 5px" icon="md-add" to="/main/questionnaireWrite">问卷填写</Button>

                <Button type="warning" v-if="select.status === '已发布'" style="margin: 0 5px" icon="ios-close" @click="unbindItem_modal">取消用户答题权限</Button>
                <Button type="warning" v-if="select.status === '已发布'" style="margin: 0 5px" icon="ios-close" @click="bitchBindItem_modal">批量绑定问卷</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table v-if="select.status === '已发布'" stripe :loading="tableLoading" :columns="columns1Published" :data="dataList"  @on-selection-change="questionnaireSelectionChange"></Table>
                <Table v-else stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" footer-hide fullscreen title="新增问卷" @on-cancel="cancelItem">
            <Layout style="height: 100%">
                <Sider class="my_Sider" width="250">
                    <div v-for="item in questionType" :key="item.name">
                        <div class="question_title">{{item.name}}</div>
                        <Button class="question_button" v-for="child in item.child" :key="child.name" @click="addQuestion(child.template)">
                            <Icon v-if="child.icon != ''" :type="child.icon" size="14" style="padding-right: 5px"/>
                            <i v-else class="iconfont">{{child.i_icon}}</i>
                            <span :class="child.class">{{child.name}}</span>
                        </Button>
                    </div>
                </Sider>
                <Layout class="my_layout">
                    <div @click="divIndex=''" style="height: 100%">

                    <!--问卷开头-->
                    <Card shadow class="my_card" :bordered="false">
                        <Form :label-width="60">
                            <FormItem style="margin: 0px">
                                <input class="my_input" v-model="QuestionnaireItem.name" style="height: 50px;font-size: 22px" placeholder="问卷标题">
                                <input class="my_input" v-model="QuestionnaireItem.introduction" style="height: 35px;font-size: 18px" placeholder="引导语">
                            </FormItem>
                            <FormItem style="margin: 0px;padding: 5px 15px">
                                <Select v-model="QuestionnaireItem.typeId" placeholder="请选择问卷类型" style="width: 400px">
                                    <Option v-for="item in QuestionnaireTypeAllList" :value="item.id" :key="item.id">
                                        {{ item.name }}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Form>
                    </Card>

                    <!--问卷初始-->
                    <div v-if="QuestionnaireItem.questionVOList.length <= 0 " class="listIsNull" :bordered="false">
                        <div>
                            <i class="iconfont" style="font-size: 20px">&#xe655;</i>
                            点击题型添加至此区域
                        </div>
                    </div>

                    <!--问卷题目-->
                    <div v-else="QuestionnaireItem.questionVOList.length > 0 ">
                        <draggable
                                class="list-group"
                                tag="ul"
                                group="questionVOList"
                                v-model="QuestionnaireItem.questionVOList"
                                v-bind="dragOptions"
                                @start="drag=true"
                                handle=".handle"
                                @end="drag=false">
                            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                <li @click.stop="divIndex=Question.key" class="list-group-item" v-for="(Question,index) in QuestionnaireItem.questionVOList" :key="Question.key">
                                    <Card :class="[divIndex===Question.key?'divActive':'','my_card_form']" :bordered="false">
                                        <i aria-hidden="true" class="glyphicon glyphicon-pushpin"></i>
                                            <Form :label-width="60">
                                            <Row>
                                                <Col span="16">
                                                    <FormItem :label="index+1+''" style="margin: 0px;">
                                                        <input class="my_input" v-model="Question.text" style="height: 35px;font-size: 18px" placeholder="请填写题目标题">
                                                    </FormItem>
                                                </Col>
                                                <Col span="5" offset="3">
                                                    <i-switch title="是否必答" size="large" v-model="Question.required" @change="changeSwitch(Question)">
                                                        <span slot="open">必答</span>
                                                        <span slot="close">选答</span>
                                                    </i-switch>
                                                    <Button title="拖动题目" class="my_Button handle">
                                                        <Icon type="md-move" size="20" />
                                                    </Button>
                                                    <Button title="复制本题" class="my_Button" @click="copyQuestion(index)">
                                                        <Icon type="md-copy" size="20"/>
                                                    </Button>
                                                    <Button title="删除题目" class="my_Button" @click="deleteQuestion(index)">
                                                        <Icon type="md-trash" size="20"/>
                                                    </Button>
                                                </Col>
                                            </Row>

                                            <div v-if="Question.type=='文本'">
                                                <Row>
                                                    <Col span="12">
                                                    <FormItem  style="margin: 0px;">
                                                        <div class="my_div" style="height: 35px;" ></div>
                                                    </FormItem>
                                                    </Col>
                                                    <Poptip placement="right">
                                                        <Button title="校验设置" class="my_Button" style="padding: 0px 13px;height: 35px">
                                                            <Icon type="md-git-network" size="20" />
                                                        </Button>
                                                        <div class="api" slot="content">
                                                            <Select  v-model="Question.optionList[0].format" placeholder="请选择">
                                                                <Option v-for="item in formatList" :value="item.id" :key="item.id">
                                                                    {{ item.name }}
                                                                </Option>
                                                            </Select>
                                                        </div>
                                                    </Poptip>
                                                    <Poptip placement="right">
                                                        <Button :title="'分值设置('+Question.optionList[0].point+')'" class="my_Button" style="padding: 0px 13px;height: 35px">
                                                            <Icon type="ios-cog" size="20" />
                                                        </Button>
                                                        <div class="api" slot="content">
                                                            <InputNumber style="width: 100%" :min="0" placeholder="请输入选项分值..."
                                                                         v-model="Question.optionList[0].point == null?Question.optionList[0].point = 0 : Question.optionList[0].point" ></InputNumber>
                                                        </div>
                                                    </Poptip>
                                                </Row>
                                            </div>

                                            <div v-if="Question.type=='单选'">
                                                <draggable
                                                        class="list-group"
                                                        tag="ul"
                                                        :group="'questionVOList'+index"
                                                        v-model="Question.optionList"
                                                        v-bind="dragOptions"
                                                        handle=".handles"
                                                        @start="drag=true"
                                                        @end="drag=false">
                                                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                                    <li class="list-group-item-options" v-for="(Option,indes) in Question.optionList" :key="Option.key">
                                                        <Row>
                                                            <Col span="12">
                                                            <FormItem  style="margin: 0px;">
                                                                <span class="input_iocn">
                                                                    <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                                                </span>
                                                                <input class="my_input input_radio" v-model="Option.text" style="height: 35px;font-size: 18px" placeholder="请填写选项">

                                                            </FormItem>
                                                            </Col>
                                                            <Button title="拖动选项" class="my_Button handles">
                                                                <Icon type="md-swap" size="20" style="transform: rotate(90deg);"/>
                                                            </Button>
                                                            <Poptip placement="right">
                                                                <Button :title="'分值设置('+Option.point+')'"  class="my_Button" style="padding: 0px 10px;height: 35px">
                                                                    <Icon type="ios-cog" size="20" />
                                                                </Button>
                                                                <div class="api" slot="content">
                                                                    <InputNumber style="width: 100%" :min="0" v-model="Option.point == null? Option.point = 0 : Option.point" placeholder="请输入选项分值..."></InputNumber>
                                                                </div>
                                                            </Poptip>
                                                            <Button title="删除选项" class="my_Button" @click="deleteOption(index, indes)">
                                                                <Icon type="ios-remove-circle-outline"size="20" />
                                                            </Button>
                                                        </Row>
                                                    </li>
                                                    </transition-group>
                                                </draggable>
                                                <Form :label-width="60" inline style="padding: 15px 0">
                                                <FormItem style="margin: 0px;">
                                                    <Button class="input_radio_button" @click="addOption(index)">
                                                        <Icon type="md-add" size="16" />
                                                        添加单个选项
                                                    </Button>
                                                </FormItem>
                                                <FormItem style="margin: 0px;">
                                                    <Button class="input_radio_button" @click="addOption_Model(index)">
                                                        <Icon type="ios-list" size="16"/>
                                                        批量添加选项
                                                    </Button>
                                                </FormItem>
                                            </Form>
                                            </div>

                                            <div v-if="Question.type=='多选'">
                                                <draggable
                                                        class="list-group"
                                                        tag="ul"
                                                        :group="'questionVOList'+index"
                                                        v-model="Question.optionList"
                                                        v-bind="dragOptions"
                                                        handle=".handles"
                                                        @start="drag=true"
                                                        @end="drag=false">
                                                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                                        <li class="list-group-item-options" v-for="(Option,indes) in Question.optionList" :key="Option.key">
                                                            <Row>
                                                                <Col span="12">
                                                                <FormItem  style="margin: 0px;">
                                                                                        <span class="input_iocn">
                                                                                            <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                                                                        </span>
                                                                    <input class="my_input input_radio" v-model="Option.text" style="height: 35px;font-size: 18px" placeholder="请填写选项">

                                                                </FormItem>
                                                                </Col>
                                                                <Button title="拖动选项" class="my_Button handles">
                                                                    <Icon type="md-swap" size="20" style="transform: rotate(90deg);"/>
                                                                </Button>
                                                                <Poptip placement="right">
                                                                    <Button :title="'分值设置('+Option.point+')'" class="my_Button" style="padding: 0px 10px;height: 35px">
                                                                        <Icon type="ios-cog" size="20" />
                                                                    </Button>
                                                                    <div class="api" slot="content">
                                                                        <InputNumber style="width: 100%" :min="0" v-model="Option.point == null? Option.point = 0 : Option.point" placeholder="请输入选项分值..."></InputNumber>
                                                                    </div>
                                                                </Poptip>
                                                                <Button title="删除选项" class="my_Button" @click="deleteOption(index, indes)">
                                                                    <Icon type="ios-remove-circle-outline"size="20" />
                                                                </Button>
                                                            </Row>
                                                        </li>
                                                    </transition-group>
                                                </draggable>
                                                <Form :label-width="60" inline style="padding: 15px 0">
                                                    <FormItem style="margin: 0px;">
                                                        <Button class="input_radio_button" @click="addOption(index)">
                                                            <Icon type="md-add" size="16" />
                                                            添加单个选项
                                                        </Button>
                                                    </FormItem>
                                                    <FormItem style="margin: 0px;">
                                                        <Button class="input_radio_button" @click="addOption_Model(index)">
                                                            <Icon type="ios-list" size="16"/>
                                                            批量添加选项
                                                        </Button>
                                                    </FormItem>
                                                </Form>
                                            </div>

                                            <div v-if="Question.type=='单选文本'">
                                                <draggable
                                                        class="list-group"
                                                        tag="ul"
                                                        :group="'questionVOList'+index"
                                                        v-model="Question.optionList"
                                                        v-bind="dragOptions"
                                                        handle=".handles"
                                                        @start="drag=true"
                                                        @end="drag=false">
                                                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                                        <li class="list-group-item-options" v-for="(Option,indes) in Question.optionList" :key="Option.key">
                                                            <Row>
                                                                <Col span="12">
                                                                <FormItem  style="margin: 0px;">
                                                                        <span class="input_iocn">
                                                                            <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                                                        </span>
                                                                    <input class="my_input input_radio" v-model="Option.text" style="height: 35px;font-size: 18px" placeholder="请填写选项">
                                                                </FormItem>
                                                                </Col>
                                                                <Button title="拖动选项" class="my_Button handles">
                                                                    <Icon type="md-swap" size="20" style="transform: rotate(90deg);"/>
                                                                </Button>
                                                                <Poptip placement="right">
                                                                    <Button :title="'分值设置('+Option.point+')'" class="my_Button" style="padding: 0px 13px;height: 35px">
                                                                        <Icon type="ios-cog" size="20" />
                                                                    </Button>
                                                                    <div class="api" slot="content">
                                                                        <InputNumber style="width: 100%" :min="0" v-model="Option.point == null? Option.point = 0 : Option.point" placeholder="请输入选项分值..."></InputNumber>
                                                                    </div>
                                                                </Poptip>
                                                                <Button title="删除选项" class="my_Button" @click="deleteOption(index, indes)">
                                                                    <Icon type="ios-remove-circle-outline"size="20" />
                                                                </Button>
                                                            </Row>
                                                        </li>
                                                    </transition-group>
                                                </draggable>
                                                <Row>
                                                    <Col span="12" >
                                                    <div style="display: flex;padding-left: 60px;align-items: center">
                                                        <span class="input_iocn">
                                                            <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                                        </span>
                                                        <div style="text-align: end;font-size: 18px;line-height: 45px;margin-left: 20px;width: 100px">其他：</div>
                                                        <div class="my_div" style="height: 35px;padding: 0" ></div>
                                                    </div>
                                                    </Col>
                                                    <Poptip placement="right">
                                                        <Button :title="'分值设置('+Question.textPoint+')'" class="my_Button" style="padding: 0px 13px;height: 45px">
                                                            <Icon type="ios-cog" size="20" />
                                                        </Button>
                                                        <div class="api" slot="content">
                                                            <InputNumber style="width: 100%" :min="0" v-model="Question.textPoint == null? Question.textPoint = 0 : Question.textPoint" placeholder="请输入选项分值..."></InputNumber>
                                                        </div>
                                                    </Poptip>
                                                    <Poptip placement="right">
                                                        <Button title="校验设置" class="my_Button" style="padding: 0px 13px;height: 45px">
                                                            <Icon type="md-git-network" size="20" />
                                                        </Button>
                                                        <div class="api" slot="content">
                                                            <Select  v-model="Question.optionList[0].format" placeholder="请选择">
                                                                <Option v-for="item in formatList" :value="item.id" :key="item.id">
                                                                    {{ item.name }}
                                                                </Option>
                                                            </Select>
                                                        </div>
                                                    </Poptip>
                                                </Row>
                                                <Form :label-width="60" inline style="padding: 15px 0">
                                                    <FormItem style="margin: 0px;">
                                                        <Button class="input_radio_button" @click="addOption(index)">
                                                            <Icon type="md-add" size="16" />
                                                            添加单个选项
                                                        </Button>
                                                    </FormItem>
                                                    <FormItem style="margin: 0px;">
                                                        <Button class="input_radio_button" @click="addOption_Model(index)">
                                                            <Icon type="ios-list" size="16"/>
                                                            批量添加选项
                                                        </Button>
                                                    </FormItem>
                                                </Form>
                                            </div>

                                            <div v-if="Question.type=='多选文本'">
                                                <draggable
                                                        class="list-group"
                                                        tag="ul"
                                                        :group="'questionVOList'+index"
                                                        v-model="Question.optionList"
                                                        v-bind="dragOptions"
                                                        handle=".handles"
                                                        @start="drag=true"
                                                        @end="drag=false">
                                                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                                        <li class="list-group-item-options" v-for="(Option,indes) in Question.optionList" :key="Option.key">
                                                            <Row>
                                                                <Col span="12">
                                                                <FormItem  style="margin: 0px;">
                                                                    <span class="input_iocn">
                                                                        <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                                                    </span>
                                                                    <input class="my_input input_radio" v-model="Option.text" style="height: 35px;font-size: 18px" placeholder="请填写选项">

                                                                </FormItem>
                                                                </Col>
                                                                <Button title="拖动选项" class="my_Button handles">
                                                                    <Icon type="md-swap" size="20" style="transform: rotate(90deg);"/>
                                                                </Button>
                                                                <Poptip placement="right">
                                                                    <Button :title="'分值设置('+Option.point+')'" class="my_Button" style="padding: 0px 10px;height: 35px">
                                                                        <Icon type="ios-cog" size="20" />
                                                                    </Button>
                                                                    <div class="api" slot="content">
                                                                        <InputNumber style="width: 100%" :min="0" v-model="Option.point == null? Option.point = 0 : Option.point" placeholder="请输入选项分值..."></InputNumber>
                                                                    </div>
                                                                </Poptip>
                                                                <Button title="删除选项"  class="my_Button" @click="deleteOption(index, indes)">
                                                                    <Icon type="ios-remove-circle-outline"size="20" />
                                                                </Button>
                                                            </Row>
                                                        </li>
                                                    </transition-group>
                                                </draggable>
                                                <!--文本-->
                                                <Row>
                                                    <Col span="12" >
                                                    <div style="display: flex;padding-left: 60px;align-items: center">
                                                        <span class="input_iocn">
                                                            <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                                        </span>
                                                        <div style="text-align: end;font-size: 18px;line-height: 45px;margin-left: 20px;width: 100px">其他：</div>
                                                        <div class="my_div" style="height: 35px;padding: 0" ></div>
                                                    </div>
                                                    </Col>
                                                    <Poptip placement="right">
                                                        <Button :title="'分值设置('+Question.textPoint+')'" class="my_Button" style="padding: 0px 13px;height: 45px">
                                                            <Icon type="ios-cog" size="20" />
                                                        </Button>
                                                        <div class="api" slot="content">
                                                            <InputNumber style="width: 100%" :min="0" v-model="Question.textPoint == null? Question.textPoint = 0 : Question.textPoint" placeholder="请输入选项分值..."></InputNumber>
                                                        </div>
                                                    </Poptip>
                                                    <Poptip placement="right">
                                                        <Button title="校验设置" class="my_Button" style="padding: 0px 13px;height: 45px">
                                                            <Icon type="md-git-network" size="20" />
                                                        </Button>
                                                        <div class="api" slot="content">
                                                            <Select  v-model="Question.optionList[0].format" placeholder="请选择">
                                                                <Option v-for="item in formatList" :value="item.id" :key="item.id">
                                                                    {{ item.name }}
                                                                </Option>
                                                            </Select>
                                                        </div>
                                                    </Poptip>
                                                </Row>
                                                <Form :label-width="60" inline style="padding: 15px 0">
                                                    <FormItem style="margin: 0px;">
                                                        <Button class="input_radio_button" @click="addOption(index)">
                                                            <Icon type="md-add" size="16" />
                                                            添加单个选项
                                                        </Button>
                                                    </FormItem>
                                                    <FormItem style="margin: 0px;">
                                                        <Button class="input_radio_button" @click="addOption_Model(index)">
                                                            <Icon type="ios-list" size="16"/>
                                                            批量添加选项
                                                        </Button>
                                                    </FormItem>
                                                </Form>
                                            </div>
                                        </Form>
                                    </Card>
                                </li>
                            </transition-group>
                        </draggable>
                    </div>

                    <!--问卷得分评定-->
                    <Card shadow style="margin-bottom: 30px" class="my_cards">
                        <Form :label-width="100">
                            <span>问卷得分评定：</span>
                            <Row type='flex' justify='end'>
                                <Col span="6">
                                    <Button type="dashed" long @click="onClickAddChoose()" icon="md-add">
                                        新增
                                    </Button>
                                </Col>
                            </Row>
                            <Table
                                    highlight-row
                                    stripe
                                    :columns="conclusionInfo" :data="conclusion"
                            ></Table>
                        </Form>
                    </Card>
                    <!--问卷结尾-->
                    <Card shadow style="margin-bottom: 30px" class="my_cards">
                        <Form :label-width="60">
                            <Row style="padding: 20px 0 0">
                                <Col span="7" offset="4">
                                <FormItem label="开始时间">
                                    <DatePicker v-model="QuestionnaireItem.startTime" type="datetime" placeholder="请选择问卷开始时间" ></DatePicker>
                                </FormItem>
                                </Col>
                                <Col span="7" offset="2">
                                <FormItem label="结束时间">
                                    <DatePicker v-model="QuestionnaireItem.endTime" type="datetime" placeholder="请选择问卷结束时间" ></DatePicker>
                                </FormItem>
                                </Col>
                            </Row>
                            <Row style="padding: 20px 0">
                                <Col span="4" offset="10">
                                <Button type="success" long :loading="addLoading" @click="addItem_modal">确认问卷</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                    </div>
                </Layout>
            </Layout>
        </Modal>
        <Modal v-model="addOptionModel" title="批量添加选项" @on-ok="addOptionList"
               @on-cancel="Options='',addOption_Model_QuestionIndex = '',addOptionModel=false">
            <p>每行代表一个选项，可以添加多个选项</p>
            <Input v-model="Options" :autosize="{minRows: 2,maxRows: 6}" type="textarea" :rows="6" />
        </Modal>
        <Modal v-model="infoModel" title="问卷详情" width="650px" on-cancel="infoItem = ''">
            <Form :label-width="100">
                <FormItem label="问卷标题：">
                    {{infoItem.name}}
                </FormItem>
                <FormItem label="引导语：">
                    {{infoItem.introduction}}
                </FormItem>
                <FormItem label="问卷类型：">
                    <span v-for="item in QuestionnaireTypeAllList" v-if="item.id == infoItem.typeId" :key="item.id">
                        {{ item.name }}
                    </span>
                </FormItem>
                <FormItem label="问卷题目：">
                    <div v-for="(question,index) in infoItem.questionVOList" :key="question.id">
                        {{index+1}}、{{question.text}} ({{question.type}})
                        <div v-if="question.type == '文本'">
                            <div style="display: flex">
                                <div class="my_divz" style="height: 35px;width: 300px" ></div>
                                <span style="font-size: 12px;padding-left: 10px;color: #BDBDBD">(分值：{{question.optionList[0].point}})</span>
                            </div>
                        </div>
                        <div v-if="question.type == '单选'">
                            <div v-for="Option in question.optionList" :key="Option.id">
                                <span class="input_iocns">
                                    <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                </span>
                                <span class="my_divs">{{Option.text}}</span>
                                <span style="font-size: 12px;padding-left: 10px;color: #BDBDBD">(选项分值：{{Option.point}})</span>
                            </div>
                        </div>
                        <div v-if="question.type == '多选'">
                            <div v-for="Option in question.optionList" :key="Option.id">
                                <span class="input_iocns">
                                    <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                </span>
                                <span class="my_divs">{{Option.text}}</span>
                                <span style="font-size: 12px;padding-left: 10px;color: #BDBDBD">(选项分值：{{Option.point}})</span>
                            </div>
                        </div>
                        <div v-if="question.type == '单选文本'">
                            <div v-for="Option in question.optionList"  :key="Option.id">
                                <div v-if="Option.format =='' ">
                                    <span class="input_iocns">
                                        <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                    </span>
                                    <span class="my_divs">{{Option.text}}</span>
                                    <span style="font-size: 12px;padding-left: 10px;color: #BDBDBD">(选项分值：{{Option.point}})</span>
                                </div>
                                <div v-if="Option.format !='' ">
                                    <span class="input_iocns">
                                        <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                    </span>
                                    <Row style="margin-left: 40px">
                                        <Col span="2">
                                        <div style="line-height: 35px">其他：</div>
                                        </Col>
                                        <Col span="12">
                                        <div class="my_divz" style="height: 35px;margin: 0px" ></div>
                                        </Col>
                                        <span style="font-size: 12px;padding-left: 10px;color: #BDBDBD">(选项分值：{{Option.point}})</span>
                                    </Row>
                                </div>
                            </div>

                        </div>
                        <div v-if="question.type == '多选文本'">
                            <div v-for="Option in question.optionList" :key="Option.id">
                                <div v-if="Option.format =='' ">
                                    <span class="input_iocns">
                                        <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                    </span>
                                    <span class="my_divs">{{Option.text}}</span>
                                    <span style="font-size: 12px;padding-left: 10px;color: #BDBDBD">(选项分值：{{Option.point}})</span>
                                </div>
                                <div v-if="Option.format !='' ">
                                    <span class="input_iocns">
                                        <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                    </span>
                                    <Row style="margin-left: 40px">
                                        <Col span="2">
                                        <div style="line-height: 35px">其他：</div>
                                        </Col>
                                        <Col span="12">
                                        <div class="my_divz" style="height: 35px;margin: 0px" ></div>
                                        </Col>
                                        <span style="font-size: 12px;padding-left: 10px;color: #BDBDBD">(选项分值：{{Option.point}})</span>
                                    </Row>
                                </div>
                            </div>

                        </div>
                    </div>
                </FormItem>
                <FormItem label="问卷得分评定：">
                    <div v-for="item in conclusion">
                       得分 >= {{ item.point }} : {{item.result}} : {{item.recommend}}
                    </div>
                </FormItem>
                <FormItem label="开始时间：">
                    {{infoItem.startTime | dateTimeToString}}
                </FormItem>
                <FormItem label="结束时间：">
                    {{infoItem.endTime | dateTimeToString}}
                </FormItem>
                <FormItem label="问卷状态：">
                    {{infoItem.status}}
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="bindModel" title="添加患者" width="750">
            <Form :label-width="100">
                <FormItem label="患者用户：">
                    <Select v-model="bindItemInfo.userId" placeholder="请选择">
                        <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                            {{ item.name }} - {{item.phone}}
                        </Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="bindLoading" @click="batchBindItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="unbindModel" title="取消患者" width="750">
            <Form :label-width="100">
                <Row>
                    <Col span="12">
                    <FormItem label="患者用户：">
                        <Select @on-change="findAllQuestionnaireUser" v-model="unbindItemInfo.userId" placeholder="请选择">
                            <Option v-for="item in userAllList"  :value="item.id" :key="item.id">
                                {{ item.name }} - {{item.phone}}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="填写问卷：">
                        <Select :loading="unbindSelect" v-model="unbindItemInfo.questionnaireId" placeholder="请选择">
                            <Option v-for="item in questionnaireUserAllList" :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="unbindLoading" @click="unbindItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="bindedModel" title="已绑定患者" width="750">
            <Table :columns="bindedUserColumns" :data="bindedUsers" style="flex: 1">
            </Table>
            <Row>
                <Col span="12" style="display: flex;justify-content: center;margin-top: 10px">
                    <Select v-model="bindItemInfo.userId" placeholder="请选择" style="width:200px; margin: 0 auto" filterable>
                        <Option v-for="item in userAllList"  :value="item.id" :key="item.id">
                            {{ item.name }} - {{item.phone}}
                        </Option>
                    </Select>
                </Col>
                <Col span="12" style="display: flex;justify-content: center;margin-top: 10px">
                    <Button  type="primary" icon="md-add" @click="bindItem">绑定</Button>
                </Col>
            </Row>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">关闭</Button>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    import draggable from "vuedraggable";
    import {question_type,format_List} from "../../json/question_type";
    export default {
        components:{
            MasterPage,
            draggable
        },
        data(){
            return{
                questionType:question_type,
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '问卷标题',
                        key: 'name',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '状态',
                        key:'status',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            return h('span', new Date(params.row.endTime) > new Date() ? params.row.status : params.row.status + '(已到期)')
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:300,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        },
                                    }
                                }, '详情'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.copyItem_modal(this.dataList[params.index])
                                        },
                                    }
                                }, '复制')
                            ]
                            switch (params.row.status) {
                                    case "未发布":
                                         Buttons.push(
                                             h('Button', {
                                                 props: {
                                                     type: 'primary',
                                                     icon: 'md-create',
                                                     label: "small",
                                                 },
                                                 style: {
                                                     marginRight: '5px'
                                                 },
                                                 on: {
                                                     click: () => {
                                                         this.updateItem_modal(this.dataList[params.index])
                                                     }
                                                 }
                                             }, '编辑'),
                                         )
                                        Buttons.push(
                                            h('Button', {
                                                props: {
                                                    type: 'success',
                                                    icon: 'logo-buffer',
                                                    label: "small",
                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.publish_modal(this.dataList[params.index])
                                                    }
                                                }
                                            }, '发布'),
                                        )
                                        break
                                    case "已发布":
                                        Buttons.push(
                                            h('Button', {
                                                props: {
                                                    type: 'primary',
                                                    icon: 'md-add',
                                                    label: "small",
                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.getBindedUser(this.dataList[params.index].id)
                                                    }
                                                }
                                            }, '绑定患者'),
                                        )
                                        Buttons.push(
                                            h('Button', {
                                                props: {
                                                    type: 'primary',
                                                    icon: 'md-trash',
                                                    label: "small",
                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.finish_modal(this.dataList[params.index])
                                                    }
                                                }
                                            }, '回收'),
                                        )
                                        break
                                }
                            if (params.row.isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else {
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon: 'md-trash',
                                            label: "small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '删除')
                                )
                            }
                            return h('div',Buttons)
                        }
                    }
                ],
                columns1Published: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '问卷标题',
                        key: 'name',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '状态',
                        key:'status',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            return h('span', new Date(params.row.endTime) > new Date() ? params.row.status : params.row.status + '(已到期)')
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:300,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        },
                                    }
                                }, '详情'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.copyItem_modal(this.dataList[params.index])
                                        },
                                    }
                                }, '复制')
                            ]
                            switch (params.row.status) {
                                    case "未发布":
                                         Buttons.push(
                                             h('Button', {
                                                 props: {
                                                     type: 'primary',
                                                     icon: 'md-create',
                                                     label: "small",
                                                 },
                                                 style: {
                                                     marginRight: '5px'
                                                 },
                                                 on: {
                                                     click: () => {
                                                         this.updateItem_modal(this.dataList[params.index])
                                                     }
                                                 }
                                             }, '编辑'),
                                         )
                                        Buttons.push(
                                            h('Button', {
                                                props: {
                                                    type: 'success',
                                                    icon: 'logo-buffer',
                                                    label: "small",
                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.publish_modal(this.dataList[params.index])
                                                    }
                                                }
                                            }, '发布'),
                                        )
                                        break
                                    case "已发布":
                                        Buttons.push(
                                            h('Button', {
                                                props: {
                                                    type: 'primary',
                                                    icon: 'md-add',
                                                    label: "small",
                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.getBindedUser(this.dataList[params.index].id)
                                                    }
                                                }
                                            }, '绑定患者'),
                                        )
                                        Buttons.push(
                                            h('Button', {
                                                props: {
                                                    type: 'primary',
                                                    icon: 'md-trash',
                                                    label: "small",
                                                },
                                                style: {
                                                    marginRight: '5px'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.finish_modal(this.dataList[params.index])
                                                    }
                                                }
                                            }, '回收'),
                                        )
                                        break
                                }
                            if (params.row.isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else {
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon: 'md-trash',
                                            label: "small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '删除')
                                )
                            }
                            return h('div',Buttons)
                        }
                    }
                ],
                bindedUserColumns: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '患者',
                        key: 'name',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:300,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.unbindItemInfo.userId = this.bindedUsers[params.index].id
                                            this.unbindItem()
                                        },
                                    }
                                }, '解除绑定'),
                            ]
                            Buttons.push(
                                h('Button', {
                                    props: {
                                        type: 'success',
                                        icon: 'logo-buffer',
                                        label: "small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remindUserToAnswer(this.bindedUsers[params.index])
                                        }
                                    }
                                }, '发送短信提醒'),
                            )
                            return h('div',Buttons)
                        }
                    }
                ],
                dataList: [],
                userAllList:[],
                questionnaireUserAllList:[],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                bindModel:false,
                bindLoading:false,
                unbindModel:false,
                unbindSelect:false,
                unbindLoading:false,
                infoModel:false,
                bindedModel: false, // 已绑定患者弹窗
                columnsInfo:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '营养物质',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h,params) => {
                            let item = this.itemAdd.nutritionTypeList[params.index]
                            return h("span",item.name + '（' + item.forShort + '） - ' +  item.englishName )
                        },
                    },
                    {
                        title: '含量',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h,params) => {
                            let item = this.itemAdd.nutritionTypeList[params.index]
                            return h("span",item.value + ' ' + item.unit )
                        },
                    },
                ],
                select:{
                    name:'',
                    typeId:'',
                    isDeleted:'false',
                    status:'未发布',
                },
                QuestionnaireTypeAllList:[],
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                QuestionnaireItem:{
                    name:'',
                    introduction:'',
                    startTime:'',
                    endTime:'',
                    typeId:'',
                    questionVOList:[],
                },
                drag:false,
                key:10,
                divIndex:'',
                addOptionModel:false,
                addOption_Model_QuestionIndex:'',
                Options:"",
                formatList:format_List,
                infoItem:"",
                bindItemInfo:{questionnaireId:'',userId:''},
                unbindItemInfo:{questionnaireId:'',userId:''},
                bindedUsers: [],
                conclusion: [],
                conclusionInfo: [
                    {
                        type: 'index',
                        width: 50,
                        align: 'center',
                    },
                    {
                        title: '分数',
                        align: 'center',
                        render: (h, params) => {
                            return h('input', {
                                domProps: {
                                    value: params.row.point
                                },
                                on: {
                                    input: (event) => {
                                        this.conclusion[params.index].point = event.target.value
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: '结论',
                        align: 'center',
                        render: (h, params) => {
                            return h('input', {
                                domProps: {
                                    value: params.row.result
                                },
                                on: {
                                    input: (event) => {
                                        this.conclusion[params.index].result = event.target.value
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: '说明',
                        align: 'center',
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    type: 'textarea',
                                    value: params.row.recommend,
                                },
                                domProps: {
                                    value: params.row.recommend,
                                },
                                on: {
                                    'on-change': (event) => {
                                        this.conclusion[params.index].recommend = event.target.value
                                    }
                                    // input: (event) => {
                                    //     this.conclusion[params.index].recommend = event.target.value
                                    // }
                                }
                            });
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        width: 200,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'error',
                                    icon: 'md-trash',
                                    label: "small",
                                },
                                on: {
                                    click: () => {
                                        this.remove(params.index)
                                    }
                                }
                            }, '删除')
                        }
                    }
                ],
                questionnaireIds: []
            }
        },
        created(){
            this.pageFindItem()
            this.pageAllQuestionnaireType()
            this.findAllUser()
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        },
        methods:{
            questionnaireSelectionChange(selection) {
              console.log('questionnaireSelectionChange: ', selection)
              this.questionnaireIds = selection.length > 0 ? selection.map(item => item.id) : null
            },
            onClickAddChoose() {
                this.conclusion = this.conclusion ? this.conclusion : []
                this.conclusion.splice(this.conclusion.length + 1, 0, {
                    point: '',
                    result: '',
                    recommend: ''
                });
            },
            remove(index) {
                this.conclusion.splice(index, 1);
            },
            // 短信提醒患者填写问卷
            remindUserToAnswer(user) {
                this.sendMessage = true
                this.$http.post('user/questionnaireRemind', {
                    userId: user.id
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.sendMessage = true
                        this.$Notice.success({title: '短信发送成功'})
                    } else {
                        this.$Notice.error({title: '短信发送失败'})
                        this.sendMessage = false
                    }
                }, function (res) {
                    this.myError(res.body)
                    this.sendMessage = false
                })
            },
            findAllQuestionnaireUser(){
                this.unbindItemInfo.questionnaireId = null
                if (this.unbindItemInfo.userId != undefined && this.unbindItemInfo.userId != ''){
                    this.unbindSelect = true
                    this.$http.post('questionnaire/getQuestionnaire',{
                        userId:this.unbindItemInfo.userId
                    }).then(function (res) {
                        let msg = res.body
                        this.unbindSelect = false
                        if (msg.success) {
                            this.questionnaireUserAllList = msg.data
                        }else {
                            this.$Notice.error({title:'患者问卷查询失败',desc: msg.message});
                        }
                    },function (res) {
                        this.unbindSelect = false
                        this.myError(res.body)
                    })
                }
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            sort() {
                this.list = this.list.sort((a, b) => a.order - b.order);
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageAllQuestionnaireType(){
                this.$http.post('questionnaire/listType',{
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.QuestionnaireTypeAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'组卷类型查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('questionnaire/list',{
                    name:this.select.name,
                    typeId:this.select.typeId == undefined ? "":this.select.typeId,
                    status:this.select.status,
                    isDeleted:this.select.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'组卷查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            changeSwitch(question){
                question.required = !question.required
            },
            addQuestion(value){
                value = JSON.parse(JSON.stringify(value))
                value.key = this.key
                this.key = this.key+1
                value.index = this.QuestionnaireItem.questionVOList.length +1 +''
                this.QuestionnaireItem.questionVOList.push(value)
            },
            copyQuestion(QuestionIndex){
                this.addQuestion(this.QuestionnaireItem.questionVOList[QuestionIndex])
            },
            deleteQuestion(QuestionIndex){
                this.QuestionnaireItem.questionVOList.splice(QuestionIndex,1)
            },
            addOption(QuestionIndex){
                let Option = {text:'',pictureUrl:'',index:'',format:'',nextQuestionId:'',key:this.key,point:0}
                this.key = this.key+1
                this.QuestionnaireItem.questionVOList[QuestionIndex].optionList.push(Option)
            },
            addOption_Model(QuestionIndex){
                this.addOptionModel=true
                this.addOption_Model_QuestionIndex = QuestionIndex
            },
            addOptionList(){
                let optionList = this.Options.split('\n')
                optionList.forEach((option)=>{
                    let Option = {text:option,pictureUrl:'',index:'',format:'',nextQuestionId:'',key:this.key,point:0}
                    this.key = this.key+1
                    this.QuestionnaireItem.questionVOList[this.addOption_Model_QuestionIndex].optionList.push(Option)
                })
                this.Options = ''
            },
            deleteOption(QuestionIndex,OptionIndex){
                this.QuestionnaireItem.questionVOList[QuestionIndex].optionList.splice(OptionIndex,1)
            },
            addItem_modal(){
                if (this.QuestionnaireItem.name.length <= 0){
                    return this.$Message.warning('请输入问卷标题');
                }
                if (this.QuestionnaireItem.introduction.length <= 0){
                    return this.$Message.warning('请输入问卷引导语');
                }
                if (this.QuestionnaireItem.typeId.length <= 0){
                    return this.$Message.warning('请选择问卷类型');
                }
                if (this.QuestionnaireItem.typeId.length <= 0){
                    return this.$Message.warning('请选择问卷类型');
                }
                if (this.QuestionnaireItem.startTime == undefined || this.QuestionnaireItem.startTime.length <= 0){
                    return this.$Message.warning('请选择问卷开始时间');
                }
                if (this.QuestionnaireItem.endTime == undefined || this.QuestionnaireItem.endTime.length <= 0){
                    return this.$Message.warning('请选择问卷结束时间');
                }
                this.$Modal.confirm({
                    title: '确认保存问卷“'+ this.QuestionnaireItem.name + '”',
                    loading:true,
                    onOk: () => {
                        this.addItem();
                    }
                });
            },
            addItem(){
                let questionIndex = 1
                let falg = false
                Questionnaire:for (var i= 0;i< this.QuestionnaireItem.questionVOList.length; i++) {
                    let question = this.QuestionnaireItem.questionVOList[i]
                    if (question.text.length <= 0 ){
                        falg = true
                        return
                    }
                    if (question.type != '文本' ){
                        for (var j= 0;j< question.optionList.length; j++) {
                            let option = question.optionList[j]
                            if (option.text.length <= 0) {
                                falg = true
                                break Questionnaire
                            }
                        }
                    }
                }
                if (falg){
                    return this.$Message.warning('请填写完整问卷数据')
                }
                let QuestionnaireItem = JSON.parse(JSON.stringify(this.QuestionnaireItem))
                QuestionnaireItem.questionVOList.forEach(function (question) {
                    question.index = questionIndex
                    questionIndex = questionIndex +1
                    let optionIndex = 1
                    if (question.type == '单选文本' || question.type == '多选文本') {
                        question.optionList.push({text:'',pictureUrl:'',index:'',format:'text',nextQuestionId:'',key:0,point:question.textPoint})
                    }
                    question.optionList.forEach(function (option) {
                        option.index = optionIndex
                        optionIndex = optionIndex +1
                    })
                })
                this.addLoading = true
                console.log('this.QuestionnaireItem.id', this.QuestionnaireItem.id)
                if (this.QuestionnaireItem.id != null) {
                    this.updateQuestionnaire(QuestionnaireItem)
                } else {
                    this.addQuestionnaire(QuestionnaireItem)
                }
            },
            // 新增问卷
            addQuestionnaire (QuestionnaireItem) {
                QuestionnaireItem.evaluation = JSON.stringify(this.conclusion) 
                this.$http.post('questionnaire/addQuestionnaire',
                    QuestionnaireItem,
                    {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '问卷新增成功'});
                        this.cancelItem()
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'问卷新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            // 保存修改的问卷
            updateQuestionnaire (QuestionnaireItem) {
                QuestionnaireItem.evaluation = JSON.stringify(this.conclusion) 
                this.$http.post('questionnaire/updateQuestionnaire',
                    QuestionnaireItem,
                    {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '问卷编辑成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'问卷编辑失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.bindModel = this.bindLoading = this.unbindModel = this.unbindLoading = this.infoModel = this.bindedModel = false
                this.QuestionnaireItem = {
                    name:'',
                    introduction:'',
                    startTime:'',
                    endTime:'',
                    typeId:'',
                    questionVOList:[],
                },
                this.bindItemInfo={questionnaireId:'',userId:''}
                this.unbindItemInfo={questionnaireId:'',userId:''}
                this.questionnaireUserAllList = []
                this.questionnaireIds = []
                this.$Modal.remove()
            },
            bitchBindItem_modal() {
              if(this.questionnaireIds.length <= 0) {
                this.$Notice.warning({title:'请先选择问题'});

              }
              this.bindModel = true
            },
            bindItem_modal(item){
                this.questionnaireIds = [item.id]
                // this.bindItemInfo.questionnaireId = item.id
                this.bindModel = true
            },
            // 根据问卷获取该问卷已绑定的患者
            getBindedUser (item) {
                if (item == null || item == '') return
                this.bindedModel = true
                this.bindedUsers = []
                this.unbindItemInfo = {questionnaireId: item,userId:''}
                this.bindItemInfo = {questionnaireId: item,userId:''}
                this.$http.post('questionnaire/getUserIdsByQuestionnaireId',{
                    questionnaireId:this.bindItemInfo.questionnaireId
                }).then(function (res) {
//                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.bindedUsers = msg.data
                    }else {
                        this.$Notice.error({title:'问卷已绑定用户失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            batchBindItem(){
                if (this.bindItemInfo == null || this.bindItemInfo.questionnaireId == null ||
                    this.bindItemInfo.userId == null || this.bindItemInfo.userId == '' ||
                    this.questionnaireIds.length <= 0 ) return
                    // this.bindItemInfo.questionnaireId == '') return
                this.bindLoading = true
                let qId = this.bindItemInfo.questionnaireId
                this.$http.post('questionnaire/batchBind',{
                    questionnaireIds: this.questionnaireIds.join(','),
                    userIds:this.bindItemInfo.userId,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.getBindedUser(qId)
                        this.$Notice.success({title: '问卷绑定用户成功'});
                    }else {
                        this.$Notice.error({title:'问卷添加用户失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.bindItemInfo={questionnaireId: qId, userId:''}
                    this.myError(res.body)
                })
            },
            bindItem(){
                if (this.bindItemInfo == null || this.bindItemInfo.questionnaireId == null ||
                    this.bindItemInfo.userId == null || this.bindItemInfo.userId == '' ||
                    // this.questionnaireIds.length <= 0 ) return
                    this.bindItemInfo.questionnaireId == '') return
                this.bindLoading = true
                let qId = this.bindItemInfo.questionnaireId
                this.$http.post('questionnaire/bindUser',{
                    questionnaireId:this.bindItemInfo.questionnaireId,
                    // questionnaireIds: this.questionnaireIds.join(','),
                    userId:this.bindItemInfo.userId,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.getBindedUser(qId)
                        this.$Notice.success({title: '问卷绑定用户成功'});
                    }else {
                        this.$Notice.error({title:'问卷添加用户失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.bindItemInfo={questionnaireId: qId, userId:''}
                    this.myError(res.body)
                })
            },
            unbindItem_modal(){
                this.unbindModel = true
            },
            unbindItem(){
                if (this.unbindItemInfo.userId == null || this.unbindItemInfo.userId === '') {
                    return this.$Notice.warning({title:'请选择患者用户'});
                }
                if (this.unbindItemInfo.questionnaireId == null || this.unbindItemInfo.questionnaireId === '') {
                    return this.$Notice.warning({title:'请选择问卷'});
                }
                let qId = this.unbindItemInfo.questionnaireId
                this.unbindLoading = true
                this.$http.post('questionnaire/unbindUser',{
                    questionnaireId:this.unbindItemInfo.questionnaireId,
                    userId:this.unbindItemInfo.userId,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.getBindedUser(qId)
                        this.$Notice.success({title: '取消用户答题权限成功'});
                    }else {
                        this.$Notice.error({title:'取消用户答题权限失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.unbindItemInfo.questionnaireId = qId
                    this.myError(res.body)
                })
            },
            publish_modal(item){
                this.$Modal.confirm({
                    title: '确认发布问卷“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.publish(item);
                    }
                });
            },
            // 编辑问卷
            updateItem_modal (item) {
                this.$http.post('questionnaire/listDetail',{
                    id:item.id,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.QuestionnaireItem = msg.data.list[0]
                        console.log('QuestionnaireItem', this.QuestionnaireItem)
                        if (this.QuestionnaireItem != null && this.QuestionnaireItem.questionVOList != null && this.QuestionnaireItem.questionVOList.length > 0) {
                            this.QuestionnaireItem.questionVOList.map((item, i) => {
                                item.key = i
                                if (item.optionList != null && item.optionList.length > 0){
                                    item.optionList.map((option, j) => {
                                        option.key = j
                                    })
                                    item.optionList.sort((a, b) => a.index - b.index)
                                }
                            })
                            this.QuestionnaireItem.questionVOList.sort((a, b) => a.index - b.index)
                        }
                        this.addModel = true
                        this.conclusion = this.QuestionnaireItem.evaluation ? JSON.parse(this.QuestionnaireItem.evaluation) : []
                    }else {
                        this.$Notice.error({title:'问卷详情失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            // 复制问卷
            copyItem_modal (item) {
                this.$http.post('questionnaire/listDetail',{
                    id:item.id,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.QuestionnaireItem = msg.data.list[0]
                        this.QuestionnaireItem.id = null
                        console.log('QuestionnaireItem', this.QuestionnaireItem)
                        if (this.QuestionnaireItem != null && this.QuestionnaireItem.questionVOList != null && this.QuestionnaireItem.questionVOList.length > 0) {
                            this.QuestionnaireItem.questionVOList.map((item, i) => {
                                item.key = i
                                if (item.optionList != null && item.optionList.length > 0){
                                    item.optionList.map((option, j) => {
                                        option.key = j
                                    })
                                    item.optionList.sort((a, b) => a.index - b.index)
                                }
                            })
                            this.QuestionnaireItem.questionVOList.sort((a, b) => a.index - b.index)
                        }
                        this.addModel = true
                        this.conclusion = this.QuestionnaireItem.evaluation ? JSON.parse(this.QuestionnaireItem.evaluation) : []
                    }else {
                        this.$Notice.error({title:'问卷详情失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            publish(item){
                this.$http.post('questionnaire/publish',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '问卷发布成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'问卷发布失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            finish_modal(item){
                this.$Modal.confirm({
                    title: '确认回收问卷“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.finish(item);
                    }
                });
            },
            finish(item){
                this.$http.post('questionnaire/finish',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '问卷回收成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'问卷回收失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用问卷“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('questionnaire/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '问卷禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'问卷禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认启用问卷“'+item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('questionnaire/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '问卷启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'问卷启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            infoItem_modal(item){
                this.$http.post('questionnaire/listDetail',{
                    id:item.id,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.infoItem = msg.data.list[0]
                        this.infoItem.questionVOList.sort((a, b) => a.index - b.index)
                        this.infoItem.questionVOList.forEach(item => {
                          item.optionList.sort((a, b) => a.index - b.index)
                        })
                        this.conclusion = this.infoItem.evaluation ? JSON.parse(this.infoItem.evaluation) : []
                    }else {
                        this.$Notice.error({title:'问卷详情失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
                this.infoModel = true
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    @font-face {
        font-family: 'iconfont';  /* project id 1253004 */
        src: url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.eot');
        src: url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.woff') format('woff'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.svg#iconfont') format('svg');
    }

    .iconfont{
        font-family:"iconfont" !important;
        font-size:14px;font-style:normal;
        padding-right: 5px;
        -webkit-font-smoothing: antialiased;
        -webkit-text-stroke-width: 0.2px;
        -moz-osx-font-smoothing: grayscale;
    }

    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
    .list-group {
        min-height: 20px;
    }

    .list-group-item {
        list-style-type:none;
        margin-bottom: 10px;
    }

    .list-group-item-options{
        list-style-type:none;
    }

    .divActive{
        border: 4px solid #2d8cf0;
        margin: 20px 0;
    }

    .ivu-modal-wrap >>> .ivu-modal-body{
        padding: 0 !important;
    }

    .ivu-layout-sider{
        background-color: #FAFAFA;
    }

    .ivu-layout{
        background-color: #F3F5F6;
    }

    .my_layout{
        padding: 30px 15px 30px 15px
    }

    ::-webkit-scrollbar {
      width: 5px;
      height: 100px;
      background-color: #F5F5F5;
    }

    /*定义滚动条轨道 内阴影+圆角*/
    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #F5F5F5;
    }

    /*定义滑块 内阴影+圆角*/
    ::-webkit-scrollbar-thumb {
      border-radius: 20px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
      background-color: rgba(0, 0, 0, .2);
    }

    /*滑块效果*/
    ::-webkit-scrollbar-thumb:hover {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px #f5f5f5;
      background: rgba(0, 0, 0, 0.3);
    }

    .my_Sider{
        padding-left: 15px;
        padding-top: 30px;
        padding-bottom: 30px;
    }

    .question_title{
        line-height: 40px;
        font-size: 14px;
    }

    .question_button{
        margin: 5px 5px 5px 0;
        width: 100px;
    }

    .my_span3 {
        letter-spacing: 4px;
    }
    .my_span2 {
        letter-spacing: 10px;
    }

    .listIsNull{
        height: 300px;
        border:1px dashed #2d8cf0;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #2d8cf0;
        font-size: 16px;
        margin: 10px 0;
    }

    .my_card_form >>> .ivu-form-item-label {
        font-size: 20px;
        line-height: 25px;
    }

    .my_card,.my_cards{
        margin: 10px 0;
    }

    .my_Button{
        height: 45px;
        border: 0;
        padding: 5px 13px 6px;
        background-color: rgba(0,0,0,0);
    }

    .my_Button:focus{
        box-shadow: 0 0 0 0;
    }
    .my_input{
        display: inline-block;
        width: 100%;
        line-height: 1.5;
        padding: 5px 15px;
        letter-spacing: 2px;
        border-radius: 4px;
        border: 0px;
        outline:none;
        color: #515a6e;
        background-color: #fff;
        background-image: none;
        position: relative;
        margin: 5px 0px;
        cursor: text;
    }

    .my_div{
        display: inline-block;
        width: 100%;
        height: 32px;
        padding: 4px 7px;
        border: 1px solid #dcdee2;
        border-radius: 4px;
        background-color: #fff;
        position: relative;
    }

    .my_divz{
        height: 30px;
        padding: 4px 7px;
        border: 1px solid #dcdee2;
        border-radius: 4px;
        background-color: #fff;
        margin-left: 20px;
    }

    .my_divs{
        line-height: 35px;
        padding-left: 40px;
    }

    .my_input:hover{
        border:1px dashed #8E8E8E;
    }
    .my_input:focus{
        background-color: #f2f5f6;
    }

    .my_input::-webkit-input-placeholder{
        color:#BEBEBE;
    }
    .my_input::-moz-placeholder{   /* Mozilla Firefox 19+ */
        color:#BEBEBE;
    }
    .my_input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color:#BEBEBE;
    }
    .my_input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
        color:#BEBEBE;
    }

    .input_iocn{
        position: absolute;
        height: 45px;
        z-index: 99;
        line-height: 45px;
        padding-left: 10px;
    }

    .input_iocns{
        position: absolute;
        height: 35px;
        line-height: 35px;
        padding-left: 20px;
    }

    .input_radio{
        padding: 4px 7px 4px 40px;
    }

    .input_radio_button{
        color: #2d8cf0;
    }

    .input_radio_button:hover{
        border-color: #fff;
        background-color: #f3f3f3;
    }

    .my_forms >>> .ivu-form-item-content{
        line-height: 0px;
    }

</style>
